module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/Close.a604ccac.svg";